// For Service PresetAssociation

import { useNuxtApp } from '#app';
import { BaseService } from '../base/base.service';
import { ModelGETPresetAssociationPreset, ModelPresetActive, type IModelGETPresetAssociationPresetResponse } from './dto/preset-asso.dto';
import { PresetAssociationRepository } from './preset-asso.repository';

export class PresetAssociationService extends BaseService {
  private presetAssociationRepository = new PresetAssociationRepository(this.api, this.configService);

  async getPresetAssociationPreset(id: string): Promise<ModelGETPresetAssociationPreset> {
    const { $functions } = useNuxtApp();
    let dataResult = new ModelGETPresetAssociationPreset();

    try {
      const res = await this.presetAssociationRepository.getPresetAssociationPreset(id);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = new ModelGETPresetAssociationPreset(resData.data);
        console.log('getPresetAssociationPreset', id, resData.data, dataResult);
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message
      });
      console.log(err, PresetAssociationService.name);
    }

    return dataResult;
  }

  async postPresetAssociationPreset(params: FormData): Promise<any> {
    const { $functions } = useNuxtApp();
    let dataResult;

    try {
      const res = await this.presetAssociationRepository.postPresetAssociationPreset(params);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = resData.data
        console.log('postPresetAssociationPreset', resData.data, dataResult);
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message
      });
      console.log(err, PresetAssociationService.name);
    }

    return dataResult;
  }

  async putPresetAssociationPreset(params: FormData): Promise<any> {
    const { $functions } = useNuxtApp();
    let dataResult;

    try {
      const res = await this.presetAssociationRepository.putPresetAssociationPreset(params);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = resData.data
        console.log('putPresetAssociationPreset', resData.data, dataResult);
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message
      });
      console.log(err, PresetAssociationService.name);
    }

    return dataResult;
  }

  async getPresetAssociationPresetActive(params: any): Promise<ModelPresetActive[]> {
    const { $functions } = useNuxtApp();
    let dataResult: ModelPresetActive[] = [];

    try {
      const res = await this.presetAssociationRepository.getPresetAssociationPresetActive(params);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = (resData.data || []).map(e => new ModelPresetActive(e));
        console.log('getPresetAssociationPresetActive', resData.data, dataResult);
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message
      });
      console.log(err, PresetAssociationService.name);
    }

    return dataResult;
  }

  async updatePresetAssociationBeginningMessageFavorite(params: any): Promise<any> {
    const { $functions } = useNuxtApp();
    let dataResult;

    try {
      const res = await this.presetAssociationRepository.updatePresetAssociationBeginningMessageFavorite(params);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = resData.data
        console.log('updatePresetAssociationBeginningMessageFavorite', resData.data, dataResult);
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message
      });
      console.log(err, PresetAssociationService.name);
    }

    return dataResult;
  }
}
